import { Component, Input } from '@angular/core';
import { Movie } from '@usheru-hff/shared/domain';

@Component({
  selector: 'ush-assets-locker-link',
  styleUrls: ['./access-locker-link.component.scss'],
  template: `
    <div class="access-locker-link__wrapper">
      @if (!hideLabel) {
        <div class="access-locker-link__header title" [attr.data-translate]="label">{{ label | translate }}</div>
      }
      <a class="access-locker-link__button" [routerLink]="routerLink" [attr.data-translate]="labelButton">
        {{ labelButton | translate }}
      </a>
    </div>
  `
})
export class AssetsLockerLinkComponent {
  @Input() movie: Movie;
  @Input() hideLabel = false;
  @Input() label = 'assets-locker.available';
  @Input() labelButton = 'assets-locker.download';

  get routerLink() {
    return `/movie/${this.movie.friendlyUrl}/press-kit`;
  }
}
